var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_15652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0003V2.50027C10 1.67327 9.327 1.00027 8.5 1.00027H7.905C7.815 0.74677 7.665 0.51627 7.451 0.34077C7.1025 0.0547696 6.649 -0.0572304 6.206 0.0297696L3.2055 0.62977C2.507 0.769769 2 1.38877 2 2.10027V11.0003H0V12.0003H12V11.0003H10ZM6.25 6.62527C5.836 6.62527 5.5 6.28927 5.5 5.87527C5.5 5.46127 5.836 5.12527 6.25 5.12527C6.664 5.12527 7 5.46127 7 5.87527C7 6.28927 6.664 6.62527 6.25 6.62527ZM9 11.0003H8V2.00027H8.5C8.7755 2.00027 9 2.22427 9 2.50027V11.0003Z",
    fill: "#3C2212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_15652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.581487b1087fa85e655941cdab276cb5.svg";
export { ForwardRef as ReactComponent };